/**
 * Where the website introduces each value-added service (user request 2026-10-18: «معرفی هر ارزش افزوده توی سایت و یک
 * دکمه یا آیکون معرفی در همه جایی که لازمه که بره توی همون صفحه مربوط بهش (یا اگر توی یک صفحه هستن همه، بره سر بلوک
 * خودش)»): one page, «سرویس‌های ویژه» on asatsp.ir, with a block of its own per service. The anchors are the website's
 * (ASA-Website src/lib/data/value-added.ts, valueAddedAnchors): change both together.
 */
export const SERVICE_INTRO_PAGE = 'https://asatsp.ir/services/value-added'

export const SERVICE_INTRO_ANCHORS: Readonly<Record<string, string>> = {
  buyerLink: 'buyer-link',
  buyerLinkDecision: 'buyer-link-decision',
  buyerLinkChat: 'buyer-link-chat',
  buyerLinkReceipt: 'buyer-link-receipt',
  referralCorrection: 'referral-correction',
  referralCancellation: 'referral-cancellation',
  referralReturn: 'referral-return',
  buyerReaction: 'buyer-reaction',
  article6: 'article6',
  sendError: 'send-error',
  batchSent: 'batch-sent',
  periodicReport: 'periodic-report',
  taxWorkspaceAlerts: 'tax-workspace-alerts',
  taxWorkspaceAutoApprove: 'tax-workspace-auto-approve',
  onlinePayment: 'online-payment',
  proforma: 'proforma',
  posAutoInvoice: 'pos-auto-invoice',
  extraUser: 'extra-user',
  printTemplate: 'print-template',
  loginRestriction: 'login-restriction',
  bulkPdf: 'bulk-pdf',
  bulkExcel: 'bulk-excel',
  bulkCancel: 'bulk-cancel',
  taxFolderZip: 'tax-folder-zip',
  stuffidCategories: 'stuffid-categories',
  costPriceForm: 'cost-price-form',
  advancedCostPriceForm: 'advanced-cost-price-form',
  buyerTaxFileInquiry: 'buyer-tax-file-inquiry',
  accountingReturns: 'accounting-returns',
}

/** The service's block on the website, or undefined for a service the website does not introduce (yet). */
export const serviceIntroUrl = (feature?: string | null): string | undefined => {
  const anchor = feature ? SERVICE_INTRO_ANCHORS[feature] : undefined
  return anchor ? `${SERVICE_INTRO_PAGE}#${anchor}` : undefined
}
